import { render, staticRenderFns } from "./IssueCardsProvidus.vue?vue&type=template&id=212cccc8&scoped=true&"
import script from "./IssueCardsProvidus.vue?vue&type=script&lang=js&"
export * from "./IssueCardsProvidus.vue?vue&type=script&lang=js&"
import style0 from "./IssueCardsProvidus.vue?vue&type=style&index=0&id=212cccc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212cccc8",
  null
  
)

export default component.exports